const formData = {
  name: '爱情岛论坛联系我们',
  formId: 'd9pn86ub4qjhggaeq1l0',
  submitAddr: 'https://readdy.ai/api/form/d9pn86ub4qjhggaeq1l0',
  isNew: true,
};

export async function get_form_url(name: string) {
  if (name === formData.name) {
    return { submitAddr: formData.submitAddr };
  }
  return { submitAddr: '' };
}